import { combineReducers } from 'redux';
import getApiReducer from '../../../common/utils/getApiReducer';
import { GET_SHOWS, GET_FEATURED_SHOW, GET_EPISODES, GET_VIDEO, RESET_SHOW_COMPLETION } from './actions';

import { FAVORITE_EPISODE_VIDEO, UNFAVORITE_EPISODE_VIDEO } from '../../library/favorites/redux/actions';

const episodesReducer = getApiReducer(GET_EPISODES);
const episodes = (state, action) => {
  const nextState = episodesReducer(state, action);

  if (action.type === `${RESET_SHOW_COMPLETION}_REQUEST`) {
    return nextState.set(
      'data',
      nextState.get('data').map(episode => {
        return episode.set('video', episode.get('video').merge({ progress: 0, complete: false }));
      })
    );
  }

  if (action.type === `${FAVORITE_EPISODE_VIDEO}_SUCCESS` && nextState.get('data')) {
    return nextState.update('data', data =>
      data.map(episode => {
        if (episode.get('id') === action.episodeId) {
          return episode.set('favorited', true);
        }
        return episode;
      })
    );
  }

  if (action.type === `${UNFAVORITE_EPISODE_VIDEO}_SUCCESS` && nextState.get('data')) {
    return nextState.update('data', data =>
      data.map(episode => {
        if (episode.get('id') === action.episodeId) {
          return episode.set('favorited', false);
        }
        return episode;
      })
    );
  }

  return nextState;
};

const video = getApiReducer(GET_VIDEO);

const shows = getApiReducer(GET_SHOWS);

const featuredShow = getApiReducer(GET_FEATURED_SHOW);

export default combineReducers({
  video,
  episodes,
  featuredShow,
  shows,
});



// WEBPACK FOOTER //
// ./src/subscription/tv/redux/reducers.js